(function() {
	angular.module('ShargoApp')
		.controller('DriverPageController', function($scope, $rootScope, $window, $timeout, Configuration, toolsService, deviceDetector){
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $rootScope.device.isDesktop ? 310 : 150,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: $rootScope.url('driver-form'),
						text: 'header.driver-page',
						target: '',
						hide: $rootScope.device.isDesktop ? false : true,
						disabled: false
					},
					profile: false
				}
			};

			$scope.selector = {
				cityTop: false,
				cityBot: false,
				vehicleTop: false,
				vehicleBot: false
			};
			$scope.cities = [
        "Barcelona", 
        "Badalona", 
        "Madrid", 
        "Sant Cugat", 
        "Zaragoza", 
        "Valencia", 
        "Las Palmas", 
        "Tenerife", 
        "Murcia",
        "Avilés",
        "Gijón",
        "Ejido",
        "Jaén",
        "Palma de Mallorca",
        "Valladolid",
        "Albacete",
        "Alicante",
        "Salamanca",
        "Talavera de la Reina",
		"Elche"
    ];
			$scope.vehicles = ["driver-page.form.vehicle.bike", "driver-page.form.vehicle.moto", "driver-page.form.vehicle.car", "driver-page.form.vehicle.van"];
			$scope.vehiclesSection = [
				{
					"url": Configuration.siteDomain + "/img/bike.png",
					"name": "driver-page.vehicle.bike"
				},
				{
					"url": Configuration.siteDomain + "/img/moto.png",
					"name": "driver-page.vehicle.moto"
				},
				{
					"url": Configuration.siteDomain + "/img/car.png",
					"name": "driver-page.vehicle.car"
				},
				{
					"url": Configuration.siteDomain + "/img/van.png",
					"name": "driver-page.vehicle.van"
				}
			];
			$scope.reasonsSection = [];
			for (var i = 1; i <= 6; ++i) {
				$scope.reasonsSection.push({
					"url": Configuration.siteDomain + "/img/svg/driver-page-group" + i + ".svg",
					"title": "driver-page.shargo.reason" +  i + ".title",
					"subtitle": "driver-page.shargo.reason" + i + ".subtitle"
				});
			}
			var driversImages = [];
			for (var i = 1; i <= 4; ++i) {
				driversImages.push(Configuration.siteDomain + "/img/drivers/driver" + i + ".jpg");
			}
			$scope.opinionsSection = [];
			for (var i = 1; i <= 4; ++i) {
				$scope.opinionsSection.push({
					"image": {'background-image': 'url(' + driversImages[i - 1] + ')'},
					"title": "driver-page.comments.comment" +  i + ".title",
					"subtitle": "driver-page.comments.comment" + i + ".subtitle",
					"text": "driver-page.comments.comment" + i + ".text"
				});
			}


			$scope.selectItem = selectItem;

			function selectItem(index, array, selector) {
				if (index > 0) {
					var aux = $scope[array][index];
					$scope[array][index] = $scope[array][0];
					$scope[array][0] = aux;

					$scope.selector[selector] = false;
				}
				else {
					$scope.selector[selector] = !$scope.selector[selector];
				}
			}

			angular.element(document).ready(function () {
				$timeout(function () {
					if ($scope.device.isPhone || $scope.device.isTablet) {
						angular.element('.shargo-section .section-content').flickity({
							adaptiveHeight: false,
							pageDots: false,
							wrapAround: true
						});

						if ($scope.device.isPhone) {
							angular.element('.comments-section .section-content').flickity({
								adaptiveHeight: false,
								prevNextButtons: false,
								wrapAround: true
							});
						}
						else {
							angular.element('.comments-section .section-content').flickity({
								adaptiveHeight: false,
								wrapAround: true
							});
						}
					}
					else {
						angular.element('.comments-section .section-content').flickity({
							adaptiveHeight: false,
							wrapAround: true
						});
					}
				});
			});
		});
})();
